'use strict';

exports.__esModule = true;
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mozart_ui = require('@pgforsta/mozart_ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribeV2 = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UnsubscribeV2, _Component);

  function UnsubscribeV2(props) {
    (0, _classCallCheck3.default)(this, UnsubscribeV2);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.state = {
      loading: true,
      loaded: false,
      error: false
    };
    _this.unsubscribeCode = _this.props.params.unsubscribeCode ? _this.props.params.unsubscribeCode : '';
    _this.clientId = _this.props.params.clientId ? _this.props.params.clientId : '';
    _this.deviceType = (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop';
    return _this;
  }

  UnsubscribeV2.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.clientId !== '' && this.unsubscribeCode !== '') {
      var data = { 'clientId': this.clientId, 'unsubscribeCode': this.unsubscribeCode };
      fetch('https://' + window.env.devHost + '/api/feedback/v2/unsubscription', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: (0, _stringify2.default)(data)
      }).then(function (response) {
        if (response.status === 200) {
          _this2.setState({
            loading: false,
            loaded: true,
            error: false
          });
        } else {
          _this2.setState({
            loading: false,
            loaded: false,
            error: true
          });
        }
      });
    }
  };

  UnsubscribeV2.prototype.render = function render() {
    var styles = require('./Unsubscribe.scss');
    var largeFont = this.deviceType === 'mobile' ? '20px' : '30px';
    var smallFont = this.deviceType === 'mobile' ? '15px' : '20px';
    return _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(_reactHelmet2.default, { title: 'UnsubscribeV2' }),
      _react2.default.createElement(
        'div',
        { className: styles.binary_notfound },
        _react2.default.createElement(
          'div',
          { style: { marginLeft: 'auto', marginRight: 'auto', width: '500px', maxWidth: '100%' } },
          _react2.default.createElement(_mozart_ui.Image, { src: '/img/broken_robot.png' })
        ),
        this.state.loading && _react2.default.createElement(
          'p',
          { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
          'Please wait...'
        ),
        this.state.error && _react2.default.createElement(
          'p',
          { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
          'Sorry, we are having technical difficulties. Please try again later!'
        ),
        this.state.loaded && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
            'You have successfully unsubscribed!'
          ),
          _react2.default.createElement(
            'p',
            { style: { fontSize: smallFont, fontWeight: 300, textAlign: 'center' } },
            'You won\'t get any further emails from us.'
          )
        )
      )
    );
  };

  return UnsubscribeV2;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  params: _react.PropTypes.object
}, _temp);
exports.default = UnsubscribeV2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Unsubscribe/UnsubscribeV2.js
// module id = 2419
// module chunks = 0